<template>
  <v-dialog :value="open" persistent max-width="450px">
    <v-card :loading="loading">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <div class="d-flex align-center">
          <v-icon size="75" :class="visibleIcon ? 'd-none' : ''" :color="iconColor">
            {{ iconName }}
          </v-icon>
          <span class="ml-4 text-body-2" v-html="message"></span>
        </div>
        <div class="d-flex flex-column pt-3 pb-3">
          <template v-if="modalTipo === 'justificar_falta'">
            <ValidationObserver>
              <form :disabled="loading">
                <e-autocomplete
                  :items="justificativas"
                  :return-object="false"
                  :item-value="(value) => value.id"
                  :item-text="(value) => value.descricao"
                  v-model="form.justificativa_id"
                  label="Selecione uma opção"
                />
                <v-file-input v-model="form.file" show-size label="Anexe um arquivo"></v-file-input>
              </form>
            </ValidationObserver>
          </template>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-for="button of buttons"
          :key="buttons.indexOf(button)"
          v-bind="button.props || {}"
          :disabled="loading"
          @click="() => button.callback()"
          type="button"
        >
          <v-icon v-if="button.icon" small left> {{ button.icon }} </v-icon>
          {{ button.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    title: "",
    message: "",
    iconName: "",
    iconColor: "",
    buttons: [],
    open: false,
    loading: false,
    visibleIcon: false,
    modalTipo: null,
    justificativas: [],
    form: {
      justificativa_id: null,
      file: null,
    },
  }),
  methods: {
    openModal(options) {
      this.open = true;
      this.title = options.title;
      this.message = options.message;
      this.iconName = options.iconName;
      this.iconColor = options.iconColor;
      this.buttons = options.buttons;
      this.visibleIcon = options.visibleIcon;
      this.loading = options.loading || false;
      this.modalTipo = options.modalTipo || null;

      if (options.justificativas) {
        this.justificativas = options.justificativas;
      }

      if (options.form) {
        this.form = options.form;
      }
    },
    setOptions(options) {
      Object.keys(options).forEach((key) => {
        this[key] = options[key];
      });
    },
  },
  mounted() {
    this.$modalsDinamic.setCallbackFunction((options) => this.openModal(options));
    this.$modalsDinamic.setCloseFunction(() => (this.open = false));
    this.$modalsDinamic.setSetOptionsFunction((options) => this.setOptions(options));
  },
};
</script>
